import React from 'react';
import './footer.scss';
import h2 from '../../assets/images/header_left_2a.png';
import h1 from '../../assets/images/header_left_1.png';

import meiqing from '../../assets/images/meiqing.png';
import contact from '../../assets/images/contact.png';

const Footer = () => (
  <div className='app-footer'>
    <div className='content'>
      <div className='content-left'>
        <span style={{ marginBottom: 30, display: 'flex' }}>
          <img src={h1} alt='' style={{ marginRight: 14, height: 30 }} />
          <img src={h2} alt='' style={{ height: 30 }} />
        </span>
        <span className={'text-sm'} style={{ color: '#222', width: 600 }}>
          美团“青山计划”于2017年8月31日发起，以“更好生活，更美自然”为愿景，携手社会各方力量，
          <br />
          联动产业链上下游，从绿色包装、低碳生态、青山科技、青山公益四个板块推动行业环保化进程。
        </span>
        <div>
          <a href='https://waimai.meituan.com/cpc/greenhill.html' target='_blank'>
            了解更多
          </a>
        </div>
        <span>
          北京三快科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          ©️meituan.com
          京ICP证070791号&nbsp;京ICP备10211739号-1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;京公安网备
          11000002002052号
        </span>
      </div>
      <div className='content-right'>
        <div style={{ display: 'flex' }}>
          <div className={'c-left'} style={{ marginRight: 16, textAlign: 'right', color: '#222' }}>
            <span style={{ fontWeight: 700, fontSize: 14, lineHeight: '19px' }}>联系我们</span>
            <span>huanbao@meituan.com</span>
          </div>
          <div className={'c-right'}>
            <img src={contact} alt='' />
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default Footer;
